import { render } from "./profileNickName.vue?vue&type=template&id=24bcc1be&scoped=true"
import script from "./profileNickName.vue?vue&type=script&lang=js"
export * from "./profileNickName.vue?vue&type=script&lang=js"

import "./profileNickName.vue?vue&type=style&index=0&id=24bcc1be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bcc1be"]])

export default __exports__